<template>
  <div>
    <layout-navbar />

    <layout-header />

    <layout-footer />

    <layout-body />
  </div>
</template>

<script>
import LayoutBody from './components/layout/Body.vue';
import LayoutFooter from './components/layout/Footer.vue';
import LayoutHeader from './components/layout/Header.vue';
import LayoutNavbar from './components/layout/Navbar.vue';

export default {
  components: {
    LayoutHeader,
    LayoutNavbar,
    LayoutBody,
    LayoutFooter
  }
};
</script>
